/* Ardor Yard Sign Builder: options, live price, artwork layout, 3D preview, proof approval, cart and quote. Ardor Printing.
New Oct 9, 2026. Started as a copy of ardor-aframe-builder-v2.js (unchanged). Loaded by sections/ardor-yardsign-builder-ws.liquid.
A yard sign is ONE board printed on one side or on both sides. Sizes, sides and packs are the yard sign product's own
variants (config JSON); the chosen pack variant goes in the cart with quantity 1, and wire H-stakes go in as a second line.
Works with ardor-yardsign-layers.js (text and clipart), ardor-yardsign3d.js (3D view) and ardor-yardsign-pdf.js (proof and print PDFs).
v2 (Oct 12, 2026): copy of ardor-yardsign-builder.js (unchanged) for sections/ardor-yardsign-builder-ws-ai-v2.liquid, with (1) finished
Ardor templates placed edge to edge (templateFit; the template PDF is made by ardor-yardsign-template.js) and (2) the cart's 20 MB upload
limit: proof, print files and the customer's original files are kept under 18 MB (fitUpload, as in ardor-aframe-builder-v2-v2.js). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- sizes, sides, packs and prices ----------
  // One Shopify variant per size, sides and pack. A pack is that many signs with the same art, sold as one cart item.
  // The section writes every variant of the product into the config: s = size ("18 x 24 in", width first),
  // d = sides ("1 side" / "2 sides"), p = pack ("10 signs"), id, c = price of the whole pack in cents, a = available.
  // Prices are changed in Shopify on the variant. FALLBACK (pack prices in cents, the numbers of the Oct 9 test build)
  // is only used when the config has no price for a variant, so a price always shows.
  var FB_PACKS = [1, 2, 5, 10, 25, 50, 100];
  var FALLBACK = {
    '12x18': [[1800, 3240, 6750, 10800, 22500, 37800, 64800], [2250, 4050, 8438, 13500, 28125, 47250, 81000]],
    '18x24': [[2400, 4320, 9000, 14400, 30000, 50400, 86400], [3000, 5400, 11250, 18000, 37500, 63000, 108000]],
    '24x18': [[2400, 4320, 9000, 14400, 30000, 50400, 86400], [3000, 5400, 11250, 18000, 37500, 63000, 108000]],
    '24x24': [[3000, 5400, 11250, 18000, 37500, 63000, 108000], [3750, 6750, 14063, 22500, 46875, 78750, 135000]],
    '24x36': [[4200, 7560, 15750, 25200, 52500, 88200, 151200], [5250, 9450, 19688, 31500, 65625, 110250, 189000]],
    '36x24': [[4200, 7560, 15750, 25200, 52500, 88200, 151200], [5250, 9450, 19688, 31500, 65625, 110250, 189000]]
  };
  var FB_STAKE = 300; // cents for one wire H-stake
  var SAFE = 0.5; // inches from the edge to the dashed red safe line
  var MAX_FILE = 25 * 1024 * 1024;
  var MATERIAL = '4 mm white corrugated plastic';

  function sizeKey(w, h) { return fmt(w) + 'x' + fmt(h); } // width first: 18x24 is portrait, 24x18 is landscape
  function fallbackCents(key, d, n) { var f = FALLBACK[key], i = FB_PACKS.indexOf(n); return f && i >= 0 ? f[d === 2 ? 1 : 0][i] : 0; }
  var SIZES = [], PACKS = [], VAR = {};
  CONF.variants.forEach(function (v) {
    var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i.exec(String((v && v.s) || ''));
    var d = parseInt(String((v && v.d) || ''), 10), n = parseInt(String((v && v.p) || ''), 10);
    if (!m || !(d === 1 || d === 2) || !(n >= 1)) return;
    var w = parseFloat(m[1]), h = parseFloat(m[2]);
    if (!(w > 0 && h > 0)) return;
    var key = sizeKey(w, h), p = Math.round(Number(v.c));
    if (!SIZES.some(function (z) { return z.key === key; })) SIZES.push({ key: key, w: w, h: h });
    if (PACKS.indexOf(n) < 0) PACKS.push(n);
    VAR[key + '|' + d + '|' + n] = { id: v.id || null, cents: isFinite(p) && p > 0 ? p : fallbackCents(key, d, n), available: v.a !== false };
  });
  var LIVE = SIZES.length > 0; // false = the config had no variants: show the FALLBACK list; Add to cart then asks the customer to call
  if (!LIVE) {
    Object.keys(FALLBACK).forEach(function (k) { var m = k.split('x'); SIZES.push({ key: k, w: +m[0], h: +m[1] }); });
    PACKS = FB_PACKS.slice();
  }
  PACKS.sort(function (a, b) { return a - b; });
  // the variant for a size, sides and pack; when the product has no such variant it cannot be ordered online
  function variantFor(key, d, n) {
    var v = VAR[key + '|' + d + '|' + n];
    return v || { id: null, cents: fallbackCents(key, d, n), available: !LIVE };
  }
  // wire H-stakes are their own small product: one variant, added as a second cart line
  var STAKE = (CONF.stake && CONF.stake.id) ? { id: CONF.stake.id, cents: Math.round(Number(CONF.stake.price)) || FB_STAKE } : { id: null, cents: FB_STAKE };
  var STAKES_ON = !!STAKE.id;

  function sizeByKey(k) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === k) return SIZES[i]; return SIZES[0]; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

  var S = { size: sizeByKey('24x18').key, sides: 1, pack: PACKS[0], stake: true, back: false, backMode: 'same', face: 'front', artVer: 0 };
  var ART = { front: null, back: null };
  var eng = null;

  // c.Wi x c.Hi is the sign in inches (width x height). c.pack is the number of signs; the cart quantity is always 1 pack.
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var z = sizeByKey(s.size), sides = Number(s.sides) === 2 ? 2 : 1;
    var n = PACKS.indexOf(Number(s.pack)) >= 0 ? Number(s.pack) : PACKS[0];
    return { size: z, Wi: z.w, Hi: z.h, sides: sides, pack: n, stake: !!s.stake && STAKES_ON, v: variantFor(z.key, sides, n), qty: 1, artVer: s.artVer };
  }
  // pack = the price of the pack; each = the price per sign; stakes = all the stakes; charged = pack + stakes
  function price(c) {
    var stakes = c.stake ? STAKE.cents * c.pack : 0;
    return { pack: c.v.cents / 100, each: c.v.cents / c.pack / 100, stakeEach: STAKE.cents / 100, stakes: stakes / 100, charged: (c.v.cents + stakes) / 100, unit: c.v.cents / 100, vid: c.v.id, disc: 0 };
  }
  // the lowest price a size can be ordered for (one single-sided sign)
  function fromCents(z) {
    var lo = 0;
    [1, 2].forEach(function (d) { PACKS.forEach(function (n) { var x = variantFor(z.key, d, n).cents; if (x > 0 && (!lo || x < lo)) lo = x; }); });
    return lo;
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function sizeLabel(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; } // width x height
  function shapeLabel(z) { return z.w === z.h ? 'Square' : (z.w > z.h ? 'Landscape' : 'Portrait'); }
  function sidesLabel(c) { return c.sides === 2 ? '2 sides (double-sided)' : '1 side'; }
  function packLabel(n) { return n + (n === 1 ? ' sign' : ' signs'); }
  function stakeCount(c) { return c.pack + ' wire H-stake' + (c.pack === 1 ? '' : 's'); }
  function stakeLabel(c) { return c.stake ? stakeCount(c) + ', one per sign' : 'None'; }
  function frontLabel(c) { return c.sides === 2 && S.backMode !== 'different' ? 'Front (same art on the back)' : 'Front'; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new size: keep the art, but fit it to the new sign shape
  function pickSize(key) {
    if (key === S.size) return;
    [ART.front, ART.back].forEach(function (a) { if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; var z = sizeByKey(key); templateFit(a, z.w, z.h); } }); // tpl: template-shaped art stays edge to edge
    set({ size: key, artVer: S.artVer + 1 });
  }
  function pickSides(n) {
    if (n === cfg().sides) return;
    var patch = { sides: n, artVer: S.artVer + 1 };
    if (n === 1) { patch.face = 'front'; patch.back = false; }
    set(patch);
    if (n === 1) view3d('front');
  }
  // the back of a double-sided sign: the same art as the front, or its own
  function pickBackMode(mode) {
    if (mode === S.backMode) return;
    var patch = { backMode: mode, artVer: S.artVer + 1 };
    if (mode === 'different') { patch.face = 'back'; patch.back = true; } // go straight to the back so its art can be added
    else { patch.face = 'front'; patch.back = false; }
    set(patch);
    view3d(S.back ? 'back' : 'front');
  }

  // ---------- artwork ----------
  function artFor(face) {
    if (face === 'back' || face === 'back-flat') {
      var c = cfg();
      if (c.sides === 2 && S.backMode === 'different') return ART.back;
      return ART.front;
    }
    return ART.front;
  }
  // v2: text, clipart and logo layers added in the builder (ardor-yardsign-layers.js). Same face rule as artFor.
  function layerFace(face) { return (face === 'back' || face === 'back-flat') && cfg().sides === 2 && S.backMode === 'different' ? 'back' : 'front'; }
  function hasLayers(f) { return !!(window.ArdorYardSignLayers && window.ArdorYardSignLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // v2 (Oct 12, 2026, same fix as ardor-aframe-builder-v2-v2.js): the cart refuses any add-to-cart request over 20 MB with "413 Request Entity Too Large", and the
  // request holds the proof, the print file(s) and the customer's original upload(s). Keep the whole upload under
  // UPLOAD_BUDGET: print files first (made smaller when needed), then the proof, then the original files while they fit.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor Yard Sign Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print file for one face again, as one flattened image of at most maxBytes (same path as signs with text or clipart)
  function smallerPrint(c, face, a, maxBytes, approval) {
    var P = window.ArdorYardSignPDF, LY = window.ArdorYardSignLayers, Wi = c.Wi, Hi = c.Hi;
    if (!P || !P.buildPrint || !LY || !LY.composite) return Promise.reject(new Error('print tools not loaded'));
    var stamp = (approval && approval.when) || stampLabel(new Date());
    return LY.composite(face, Wi, Hi, a).then(function (r) { return shrinkImage(r.file, maxBytes - 65536); }).then(function (file) {
      return P.buildPrint({ title: 'Ardor Yard Sign Print File', stamp: stamp, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125,
        faces: [{ art: { file: file, name: file.name, kind: 'image', bg: '#FFFFFF' }, bg: '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } }] }, false);
    }).then(function (r) { return r && r.blob; });
  }
  function fitUpload(c, files, approval) {
    var backDiff = c.sides === 2 && S.backMode === 'different';
    var faces = backDiff ? ['front', 'back'] : ['front'];
    var size = function (b) { return b ? b.size : 0; };
    files.skipArt = { front: false, back: false }; files.needEmail = false;
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var prints = function () { return faces.reduce(function (t, f) { return t + size(files[f]); }, 0); };
    var total = function () { return size(files.proof) + prints() + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
    // 1. each print file gets an equal share of what the proof leaves
    var share = Math.max(1572864, Math.floor((UPLOAD_BUDGET - size(files.proof) - 262144) / faces.length));
    var chain = Promise.resolve();
    faces.forEach(function (f) {
      chain = chain.then(function () {
        var bl = files[f]; if (!bl || bl.size <= share) return null;
        return smallerPrint(c, f, ART[f], share, approval).then(function (nb) {
          if (nb && nb.size < bl.size) {
            files[f] = nb;
            files.notes.push('The ' + f + ' print file was made at a lower resolution (' + fmtMB(bl.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
          }
        }, function () { return null; });
      });
    });
    return chain.then(function () {
      // 2. the customer's original files, while they still fit
      var used = size(files.proof) + prints();
      faces.forEach(function (f) {
        var o = orig(f); if (!o) return;
        if (used + o.size <= UPLOAD_BUDGET) { used += o.size; return; }
        files.skipArt[f] = true;
        if (!files[f]) files.needEmail = true;
        files.notes.push('The customer\'s original ' + f + ' file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files[f] ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      // 3. last resort: a print file that could not be made small enough stays out
      ['back', 'front'].forEach(function (f) {
        if (total() <= UPLOAD_BUDGET || !files[f]) return;
        files.notes.push('The ' + f + ' print file (' + fmtMB(files[f].size) + ') was too large to attach. Make it from the original artwork.');
        files[f] = null;
        if (files.skipArt[f] || !orig(f)) files.needEmail = true;
      });
      return files;
    });
  }
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (a && a.guides === 'on' && notes.indexOf(GUIDES_ON_NOTE) < 0) notes.push(GUIDES_ON_NOTE);
    if (!hasLayers(f) && !(a && a.guides === 'off')) return Promise.resolve(mkJob(a));
    if (a && a.guides === 'off' && notes.indexOf(GUIDES_OFF_NOTE) < 0) notes.push(GUIDES_OFF_NOTE); // tpl: flattened, without the hidden guides
    return window.ArdorYardSignLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (hasLayers(f) && notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorYardSignLayers; if (!LY || !LY.list) return '';
    var keys = c.sides === 2 && S.backMode === 'different' ? ['front', 'back'] : ['front'];
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? (k === 'front' ? 'Front: ' : 'Back: ') : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  function geom(a, Wi, Hi) {
    var ia = a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW };
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorYardSignLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      ctx.drawImage(a.img, g.x, g.y, g.w, g.h);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorYardSignLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor Yard Sign Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // A file added while the Back tab shows "Same on both sides" is art for the back, so the sign switches to "Different back".
  function uploadFace(file) {
    if (S.face !== 'back') return 'front';
    if (file && file.size <= MAX_FILE && cfg().sides === 2 && S.backMode !== 'different') {
      S.backMode = 'different'; S.back = true; S.artVer++;
      toast('This art goes on the back. The front keeps its own art.');
    }
    return 'back';
  }

  // tpl (Oct 12, 2026): finished Ardor templates. A file the shape of the print template for this size (within 1%) goes on
  // edge to edge (Fill), not shrunk into the safe area. The template page is the print file: the exact sign size, no bleed.
  // AI designs (the "ardor-ai-..." files the AI drawer places) are made at the sign's shape already and keep their own message.
  // A PDF made from our template may still hold the "Ardor guides - hide before saving" layer (window.ArdorYardSignTemplate.guides):
  // turned on, the customer is told; switched off, the print file and proof are made from the flattened preview, because
  // the vector copy of the file would print the hidden guides.
  var TPL_MSG = 'Template file detected - placed edge to edge';
  var GUIDES_ON_NOTE = 'The customer\'s PDF still has the Ardor template guides layer turned on (cut edge, dashed line and notes), so the guides are on the proof and in the print file. The customer was asked to hide it.';
  var GUIDES_OFF_NOTE = 'The customer\'s PDF has the Ardor template guides layer switched off. The print file was made from a flattened image of the file so the hidden guides do not print. Check it against the original file.';
  function templateFit(a, Wi, Hi) {
    if (!a) return false;
    a.template = false;
    if (!(a.natW > 1 && a.natH > 1) || !(Wi > 0 && Hi > 0) || /^ardor-ai-/i.test(a.name || '')) return false;
    var ia = a.natW / a.natH, ta = Wi / Hi;
    if (Math.abs(ia - ta) / ta > 0.01) return false;
    a.mode = 'fill'; a.rcx = 0.5; a.rcy = 0.5; a.template = true;
    return true;
  }
  function templateCheck(a) {
    var c = cfg(), fit = templateFit(a, c.Wi, c.Hi);
    var warn = a.guides === 'on' ? 'Your file still has the Ardor guides layer turned on: hide it before you save, or the guide lines will print.' : '';
    if (fit || warn) toast(((fit ? TPL_MSG + '. ' : '') + warn).trim());
  }
  // after a PDF/AI preview: look for the template guides layer, then fit (part of a.ready, so the cart waits for it)
  function tplScan(a) {
    var T = window.ArdorYardSignTemplate;
    var p = T && T.guides && a.file ? T.guides(a.file) : Promise.resolve('');
    return p.then(function (st) { a.guides = st || ''; }, function () { a.guides = ''; }).then(function () {
      if (ART.front === a || ART.back === a) templateCheck(a);
    }).catch(function () {});
  }
  function loadFile(file, face) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF' };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a); templateCheck(a);
      ART[face] = a; S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; return tplScan(a); }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a || ART.back === a) { S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your sign, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your sign.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your sign.' + tail;
  }
  function needsEmailProof() {
    var c = cfg(), used = [ART.front]; if (c.sides === 2 && S.backMode === 'different') used.push(ART.back);
    return used.some(function (x) { return x && x.noPreview; });
  }

  // ---------- flat sign drawing (2D editor and the 3D sign faces) ----------
  // Where the two legs of a wire H-stake slide into the bottom edge, in inches from the left edge. A guide for the
  // drawing only (the same spacing the 3D view uses), not a stake measurement.
  function stakeLegs(Wi) { var half = Math.max(4, Math.min(10, Wi * 0.5)) / 2; return [Wi / 2 - half, Wi / 2 + half]; }
  function drawFlat(ctx, c, Wi, Hi, face, guides) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Hi * 0.1, Wi * 0.065) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork goes here', Wi / 2, Hi / 2);
    }
    if (!guides) return;
    var lw = Math.max(Wi, Hi) / 600;
    ctx.save();
    // safe line: keep text inside it
    ctx.setLineDash([]); ctx.lineWidth = lw * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    // H-stakes: two faint marks at the bottom edge, where the stake legs go
    if (c.stake) {
      var len = Math.min(4, Hi * 0.2);
      stakeLegs(Wi).forEach(function (x) {
        ctx.setLineDash([]); ctx.lineWidth = lw * 4; ctx.strokeStyle = 'rgba(255,255,255,0.5)';
        ctx.beginPath(); ctx.moveTo(x, Hi); ctx.lineTo(x, Hi - len); ctx.stroke();
        ctx.setLineDash([lw * 3.5, lw * 3]); ctx.lineWidth = lw * 1.8; ctx.strokeStyle = 'rgba(22,22,27,0.45)';
        ctx.beginPath(); ctx.moveTo(x, Hi); ctx.lineTo(x, Hi - len); ctx.stroke();
      });
    }
    ctx.setLineDash([]);
    ctx.restore();
  }

  // ---------- flat layout editor ----------
  var lay = { canvas: null, scale: 1, drag: false, lx: 0, ly: 0 };
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 420;
    var cssW = maxW, cssH = cssW * Hi / Wi;
    if (cssH > maxH) { cssH = maxH; cssW = cssH * Wi / Hi; }
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = Math.round(cssW) + 'px'; cv.style.height = Math.round(cssH) + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    lay.scale = cssW / Wi;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cv.width / Wi, 0, 0, cv.height / Hi, 0, 0);
    drawFlat(ctx, c, Wi, Hi, S.face === 'back' ? 'back-flat' : 'front', true);
  }

  function editingArt() { return S.face === 'back' ? (S.backMode === 'different' ? ART.back : null) : ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(); if (!a || !a.img) return;
      lay.drag = true; lay.lx = e.clientX; lay.ly = e.clientY;
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { lay.drag = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  function resIssue(a, c) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, c.Wi, c.Hi), ppi = Math.round(a.natW / g.w);
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or pick a smaller sign.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    var c = cfg();
    var two = c.sides === 2, backDiff = two && S.backMode === 'different';
    if (!two && S.face === 'back') { S.face = 'front'; S.back = false; }
    var a = editingArt();
    $('[data-abb-art-tabs]').hidden = !two;
    $$('[data-abb-face]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var sameBack = S.face === 'back' && !backDiff;
    $('[data-abb-drop]').hidden = sameBack;
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = S.face === 'back' ? 'Upload art for the back' : 'Upload artwork';
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name + (a.template && a.mode === 'fill' ? ' (template, edge to edge)' : '')) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (sameBack) { empty.hidden = false; empty.textContent = 'The back shows the same art as the front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the sign will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.face === 'back' ? 'No art for the back yet. Upload it above.' : 'No artwork yet. Upload yours above.'; }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
    }
    // image resolution on every printed side; the worse one is shown, in the footer, where it is always in view
    var rf = resIssue(ART.front, c), rb = backDiff ? resIssue(ART.back, c) : null;
    var worst = rf && rb ? (rb.level === 'bad' && rf.level !== 'bad' ? 'back' : 'front') : (rf ? 'front' : (rb ? 'back' : ''));
    if (worst) {
      var r = worst === 'back' ? rb : rf;
      msg = (backDiff ? (worst === 'back' ? 'The image for the back' : 'The image for the front') : 'This image') + r.text; level = r.level;
    }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
  }

  // ---------- render ----------
  function specLines(c) {
    return [['Size', sizeLabel(c)], ['Sides', sidesLabel(c)], ['Quantity', packLabel(c.pack)], ['H-stakes', stakeLabel(c)]];
  }

  function sidesNote(c) {
    return c.sides === 2 ? 'One board, printed on both sides.' : 'One board, printed on the front.';
  }

  function render() {
    var c = cfg();
    var p = price(c);

    // size: the six sizes with a "from" price. The stage turns landscape or portrait from the size itself.
    fill($('[data-abb-sizes]'), SIZES.map(function (z) {
      var html = '<span class="abb-opt__name">' + esc(fmt(z.w) + ' x ' + fmt(z.h) + ' in') + '</span><span class="abb-opt__sub">' + esc(shapeLabel(z) + ': ' + fmt(z.w) + ' in wide, ' + fmt(z.h) + ' in tall') + '</span><span class="abb-opt__price">from ' + money(fromCents(z) / 100) + '</span>';
      return optBtn({ on: z.key === c.size.key, html: html, data: ['size', z.key], pick: function () { pickSize(z.key); } });
    }));

    // sides: one board, printed on one side or on both
    fill($('[data-abb-sides]'), [
      optBtn({ on: c.sides === 1, data: ['sides', 1], html: '<span class="abb-opt__name">1 side</span><span class="abb-opt__sub">Printed on the front</span>', pick: function () { pickSides(1); } }),
      optBtn({ on: c.sides === 2, data: ['sides', 2], html: '<span class="abb-opt__name">2 sides</span><span class="abb-opt__sub">Double-sided: printed front and back</span>', pick: function () { pickSides(2); } })
    ]);
    setText('[data-abb-sides-note]', sidesNote(c));
    var bmWrap = $('[data-abb-backmode-wrap]'); if (bmWrap) bmWrap.hidden = c.sides !== 2;
    fill($('[data-abb-backmodes]'), [
      optBtn({ chip: true, on: S.backMode !== 'different', data: ['backmode', 'same'], label: 'Same on both sides', pick: function () { pickBackMode('same'); } }),
      optBtn({ chip: true, on: S.backMode === 'different', data: ['backmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different'); } })
    ]);

    // quantity: packs of signs, each with its own price and the price per sign
    fill($('[data-abb-packs]'), PACKS.map(function (n) {
      var v = variantFor(c.size.key, c.sides, n);
      var html = '<span class="abb-opt__name">' + esc(packLabel(n)) + '</span><span class="abb-opt__sub">' + (n > 1 ? money(v.cents / n / 100) + ' per sign' : 'One sign') + '</span><span class="abb-opt__price">' + (v.cents > 0 ? money(v.cents / 100) : 'Call us') + '</span>';
      return optBtn({ on: n === c.pack, html: html, data: ['pack', n], disabled: !v.available || !(v.cents > 0), pick: function () { set({ pack: n }); } });
    }));

    // H-stakes: one per sign
    var stWrap = $('[data-abb-stake-wrap]'); if (stWrap) stWrap.hidden = !STAKES_ON;
    fill($('[data-abb-stakes]'), [
      optBtn({ on: !c.stake, data: ['stake', 'no'], html: '<span class="abb-opt__name">No stakes</span><span class="abb-opt__sub">Signs only</span>', pick: function () { set({ stake: false }); } }),
      optBtn({ on: c.stake, data: ['stake', 'yes'], html: '<span class="abb-opt__name">Add H-stakes</span><span class="abb-opt__sub">' + money(p.stakeEach) + ' each, one per sign</span>', pick: function () { set({ stake: true }); } })
    ]);
    setText('[data-abb-stake-note]', c.stake
      ? stakeCount(c) + ', one per sign: ' + money(p.stakes) + ' (' + money(p.stakeEach) + ' each). The stake legs slide into the bottom edge of the sign.'
      : 'Add wire H-stakes, one per sign, for ' + money(p.stakeEach) + ' each.');

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then the pack price with the price per sign, and the stakes
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.pack < 2 && !c.stake;
    eachEl.textContent = packLabel(c.pack) + ': ' + money(p.pack) + (c.pack > 1 ? ' (' + money(p.each) + ' per sign)' : '') + (c.stake ? ' + ' + c.pack + ' H-stake' + (c.pack === 1 ? '' : 's') + ': ' + money(p.stakes) : '');
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', sizeLabel(c) + ' sign');
    setText('[data-abb-chip-mat]', sidesLabel(c));
    setText('[data-abb-chip-sides]', packLabel(c.pack) + (c.stake ? ' + H-stakes' : ''));
    setText('[data-abb-tip]', c.stake ? 'Keep text inside the red line. Stakes go in the bottom edge.' : 'Keep text inside the red line');
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorYardSign3D, three.js). Everything else works without it. ----------
  var faceCv = { front: null, back: null }, faceSent = { front: '', back: '' }, engSent = '', syncQueued = false;
  function paintFaceCanvas(c, face) {
    var k = Math.min(100, 1400 / Math.max(c.Wi, c.Hi));
    var w = Math.round(c.Wi * k), h = Math.round(c.Hi * k);
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(w / c.Wi, 0, 0, h / c.Hi, 0, 0);
    drawFlat(ctx, c, c.Wi, c.Hi, face === 'back' ? 'back-flat' : 'front', false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height + '|' + engSent : 'none';
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv);
  }
  function sync3d() {
    if (!eng) { drawPoster(); return; } // YARD3D
    var c = cfg();
    try {
      var key = [c.Wi, c.Hi, c.sides, c.stake ? 1 : 0].join('|');
      if (key !== engSent) { engSent = key; eng.set({ w: c.Wi, h: c.Hi, sides: c.sides, stake: c.stake }); }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 ? paintFaceCanvas(c, 'back') : null);
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (syncQueued) return; // YARD3D: was (!eng || syncQueued); sync3d() draws the poster until the 3D view runs
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } else pendingView = which; }
  // YARD3D (Oct 20, 2026): the WebGL 3D view no longer starts while the page loads (it was a big phone speed cost).
  // Until it starts, the 3D box shows a still, flat picture of the sign (poster, drawn by ArdorYardSign3D.poster with a 2D canvas).
  // It starts after the visitor's first touch, scroll, wheel, mouse move or key press (in idle time) or 8 s after load, and at once
  // when something needs it: a click on the 3D box, the 3D button or the 3D tools, and the proof's 3D views (proofViews). Undo:
  // restore assets/ardor-yardsign-builder-v2-backup-oct20y3.js and assets/ardor-yardsign3d-backup-oct20y3.js.
  var engTried = false, posterCv = null, posterRO = null, posterSz = '', pendingView = '';
  function drawPoster() {
    if (eng || engTried) return;
    var Y3 = window.ArdorYardSign3D, host = $('[data-abb-canvas]');
    if (!Y3 || typeof Y3.poster !== 'function' || !host) return;
    if (!posterCv) {
      posterCv = document.createElement('canvas'); posterCv.className = 'abb-poster'; posterCv.setAttribute('aria-hidden', 'true');
      posterCv.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;display:block;pointer-events:none';
      try { if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (e) {}
      host.appendChild(posterCv);
      if (typeof ResizeObserver !== 'undefined') { try { posterRO = new ResizeObserver(function () { if (posterCv && host.clientWidth + 'x' + host.clientHeight !== posterSz) drawPoster(); }); posterRO.observe(host); } catch (e) {} }
    }
    posterSz = host.clientWidth + 'x' + host.clientHeight;
    var c = cfg();
    try { Y3.poster(posterCv, { w: c.Wi, h: c.Hi, sides: c.sides, stake: c.stake }, paintFaceCanvas(c, 'front'), '#ffffff'); } catch (e) {}
  }
  function dropPoster() {
    var p = posterCv; posterCv = null; if (posterRO) { try { posterRO.disconnect(); } catch (e) {} posterRO = null; }
    if (!p) return;
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    raf(function () { raf(function () { if (p.parentNode) p.parentNode.removeChild(p); }); }); // after the 3D view's first frame
  }
  function defer3D() {
    var fired = false, evs = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel', 'scroll'];
    var idle = function (f, t) { if (window.requestIdleCallback) requestIdleCallback(function () { f(); }, { timeout: t }); else setTimeout(f, 1); };
    var go = function () { if (fired) return; fired = true; evs.forEach(function (e) { removeEventListener(e, go, true); }); idle(startEngine, 1500); };
    evs.forEach(function (e) { addEventListener(e, go, { capture: true, passive: true }); });
    document.addEventListener('click', function (e) { var t = e.target; if (!engTried && t && t.closest && t.closest('[data-abb-viewer], [data-abx-3d], [data-abx-mode="3d"]')) startEngine(); }, true);
    var later = function () { setTimeout(go, 8e3); };
    if (document.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
  }
  function startEngine() {
    if (engTried) return;
    engTried = true;
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorYardSign3D && host) ? window.ArdorYardSign3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { dropPoster(); if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
    dropPoster(); // YARD3D
    if (pendingView) { var pv = pendingView; pendingView = ''; view3d(pv); }
  }

  // ---------- proof sheet and print files ----------
  function proofCanvas(face, overlayOnly) {
    var c = cfg(), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var drewArt = overlayOnly || paintFace(ctx, Wi, Hi, face === 'back' ? 'back-flat' : 'front');
    if (overlayOnly && hasLayers(layerFace(face === 'back' ? 'back-flat' : 'front'))) window.ArdorYardSignLayers.paint(ctx, Wi, Hi, layerFace(face === 'back' ? 'back-flat' : 'front')); // v2
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Hi * 0.1, Wi * 0.06) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork', Wi / 2, Hi / 2);
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = u * 7; ctx.strokeStyle = 'rgba(255,255,255,0.85)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([u * 18, u * 12]); ctx.lineWidth = u * 4; ctx.strokeStyle = 'rgba(189,37,44,0.98)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([]);
    ctx.lineWidth = u * 2; ctx.strokeStyle = '#0C0D0D'; ctx.strokeRect(0, 0, Wi, Hi);
    ctx.restore();
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var ia = nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi };
      var fw = Math.min(Wi, Hi * ia), fh = fw / ia;
      return { x: (Wi - fw) / 2, y: (Hi - fh) / 2, w: fw, h: fh, note: 'The uploaded PDF is a different shape than the sign, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
  }

  function loadPdfTool() {
    if (window.ArdorYardSignPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorYardSignPDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    if (a.mode === 'fill') return a.template ? 'Template file, placed edge to edge' : 'Fill sign (edges may crop)';
    if (a.mode === 'fit') return 'Fit whole image, background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from sign top-left, background ' + a.bg;
  }
  function artworkLabel() { return ART.front ? ART.front.name : (hasLayers('front') ? 'Text and clipart added in the builder' : 'None'); }
  function backLabel() { return S.backMode === 'different' ? (ART.back ? ART.back.name : (hasLayers('back') ? 'Text and clipart added in the builder' : 'Different art')) : 'Same as front'; }

  function proofSpecs(c) {
    var out = [
      ['Size', sizeLabel(c) + ' (' + shapeLabel(c.size).toLowerCase() + ')'],
      ['Material', MATERIAL],
      ['Sides', sidesLabel(c)],
      ['Quantity', packLabel(c.pack)],
      ['H-stakes', stakeLabel(c)],
      ['Delivery', 'Free US shipping or pickup in Snohomish']
    ];
    out.push(['Artwork', artworkLabel()]);
    var pl = placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel()]);
    if (c.sides === 2 && S.backMode === 'different') { var pb = placementText(ART.back, c); if (pb) out.push(['Back placement', pb]); }
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
startEngine(); // YARD3D: the proof's 3D views start the 3D view if it has not started yet
try { sync3d(); } catch (e) {}
if (!eng || typeof eng.snapshot !== 'function') return out;
[['home', 'From the front'], (c.sides === 2 ? ['back', 'From the back'] : ['side', 'From the side'])].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = c.pack > 1 ? 'yard signs' : 'yard sign'; o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorYardSignPDF, Wi = c.Wi, Hi = c.Hi;
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var out = { notes: [], proof: null, front: null, back: null };
      var dimW = fmt(Wi) + ' in', dimH = fmt(Hi) + ' in';
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      var mkProofFace = function (label, faceKey, a) {
        var va = a && a.guides === 'off' ? null : vectorArt(a); // tpl: the vector copy would show hidden template guides
        return { label: label, canvas: proofCanvas(faceKey, !!va), fallback: va ? proofCanvas(faceKey, false) : null, wIn: Wi, hIn: Hi, wLabel: dimW, hLabel: dimH, underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var faces = [mkProofFace(frontLabel(c), 'front', ART.front)];
      if (backDiff) faces.push(mkProofFace('Back', 'back', ART.back));
      var date = (approval && approval.when) || stampLabel(new Date());
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor Yard Sign Proof', panelTitle: c.pack > 1 ? 'Your yard signs' : 'Your yard sign', sideBySide: true,
          legend: 'Dashed red line: keep text inside it. Print size ' + sizeLabel(c) + ' (width x height), no bleed.',
          approval: approval || null, date: date, faces: faces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var arts = [ART.front]; if (backDiff) arts.push(ART.back);
      var printable = function (a, i) { return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(i ? 'back' : 'front'); }; // v2: text-only signs print too
      var printP = Promise.resolve();
      // print files: one PDF per printed side that has its own art
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (!arts.every(printable)) out.notes.push('Print files were not made automatically for this file type. Use the original artwork file.');
      else {
        if (arts.some(function (a) { return a && a.src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        // exact sign size, no bleed, no marks. buildPrint takes the size in feet.
        var mkJob = function (a) {
          if (a.rotated && out.notes.indexOf(ROT_NOTE) < 0) out.notes.push(ROT_NOTE);
          return { title: 'Ardor Yard Sign Print File', stamp: date, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125, faces: [{ art: a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }] };
        };
        var keep = function (r) { r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); }); return r.blob; };
        printP = layerJob(mkJob, ART.front, 'front', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r) { // v2
          out.front = keep(r);
          if (!backDiff) return null;
          return layerJob(mkJob, ART.back, 'back', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r2) { out.back = keep(r2); });
        }).catch(function (e) { out.front = null; out.back = null; out.notes.push('Print files could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_yardsign_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_yardsign_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = [[frontLabel(c), 'front', ART.front]];
      if (backDiff) faces.push(['Back', 'back', ART.back]);
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your yard sign proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + sizeLabel(c) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var PL = window.ArdorProofLater; if (PL && PL.on() && !(window.ArdorArtLink && window.ArdorArtLink.emailChosen(root))) { e.preventDefault(); var plr = PL.approve(root); if (plr) closeApproval(plr); return; } // DSN Oct 25 2026: one approval box now; name + typed signature in the cart, email + phone at checkout
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // Line 1: the pack variant (size, sides and pack), quantity 1, with everything else as line item properties.
  // Line 2, only with H-stakes: the stake product, quantity = the number of signs in the pack.
  function setupMsg() { return 'Online ordering for this sign is being set up. Call ' + PHONE + ' or request a quote.'; }

  // second cart line: wire H-stakes, one per sign. Tried three times.
  function addStakeLine(count) {
    var send = function () {
      return fetch(CONF.cartAddUrl || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: STAKE.id, quantity: count, properties: { 'For': 'Yard signs' } })
      }).then(function (r) { if (!r.ok) throw new Error('stakes'); });
    };
    var again = function () { return new Promise(function (res) { setTimeout(res, 700); }).then(send); };
    return send().catch(again).catch(again);
  }

  var stakeFail = false; // the signs are in the cart, but the H-stake line could not be added
  function addToCart() {
    if (stakeFail) { window.location.href = CONF.cartUrl || '/cart'; return; }
    showErr('');
    var c = cfg(); var p = price(c);
    if (!p.vid || !c.v.available || (c.stake && !STAKE.id)) { showErr(setupMsg()); return; }
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    if (!ART.front && !hasLayers('front') && !artLink) {
      if (S.face !== 'front') { S.face = 'front'; S.back = false; render(); }
      showErr('Upload your artwork first.');
      return;
    }
    var backDiff = c.sides === 2 && S.backMode === 'different';
    if (backDiff && !ART.back && !hasLayers('back')) {
      if (S.face !== 'back') { S.face = 'back'; S.back = true; render(); }
      showErr('Upload the art for the back, or choose "Same on both sides".');
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false, proofEmail = ''; // ART0: proofEmail
    var waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // v2: stay under the cart's 20 MB upload limit
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', '1');
      fd.append('properties[Size]', sizeLabel(c));
      fd.append('properties[Sides]', sidesLabel(c));
      fd.append('properties[Quantity]', packLabel(c.pack));
      fd.append('properties[H-stakes]', c.stake ? 'Yes, ' + stakeCount(c) + ' (see the H-stake line in this order)' : 'None');
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel());
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor Yard Sign Builder');
        if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
        if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
        if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
      var pl = placementText(ART.front, c); if (pl) fd.append('properties[_Art placement]', pl);
      if (backDiff) { var pb = placementText(ART.back, c); if (pb) fd.append('properties[_Back placement]', pb); }
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the builder]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor Yard Sign Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Yard Sign Proof'));
      else if (files.proof) fd.append('properties[_Ardor Yard Sign Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Yard Sign Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing'); // ART0
      if (approval) {
        if (!approval.later) fd.append('properties[Approved by]', approval.name); // DSN: the name comes with the cart signature
        fd.append('properties[Approved on]', approval.when);
        if (!approval.later) fd.append('properties[_Approver email]', approval.email); // DSN: email + phone come from checkout
        if (!approval.later) fd.append('properties[_Approver phone]', approval.phone); else { fd.append('properties[Proof approval]', approval.later); fd.append('properties[_Proof sign]', 'cart'); } // DSN
      }
      var tooBig = false;
      [['front', 'Front'], ['back', 'Back']].forEach(function (k) {
        var bl = files[k[0]]; if (!bl) return;
        if (bl.size <= MAXPDF) fd.append('properties[_Ardor Yard Sign Print File ' + k[1] + ' - ' + labelStamp + ']', pdfFile(bl, 'Ardor Yard Sign Print File ' + k[1]));
        else tooBig = true;
      });
      if (tooBig) files.notes.push('A print file was over 25 MB, so it was not attached. Use the original artwork file.');
      var pnote = ['Yard sign ' + sizeLabel(c) + ' (width x height), ' + sidesLabel(c) + ', pack of ' + packLabel(c.pack) + ', H-stakes: ' + (c.stake ? 'yes (' + c.pack + ')' : 'no') + '.'];
      if (c.sides === 2) pnote.push('One board per sign, printed on both sides.' + (backDiff ? ' Different art on the back: use the front file and the back file.' : ' Same art on both sides: print the front file on both sides.'));
      if (files.front) pnote.push('Print file' + (files.back ? 's are' : ' is') + ' the exact finished size, no bleed, no marks, 100% scale.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      var skipArt = files.skipArt || {};
      if (ART.front && !skipArt.front) fd.append('properties[Ardor Yard Sign Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor Yard Sign Artwork ' + fileStamp + ext(ART.front.name));
      if (backDiff && ART.back && !skipArt.back) fd.append('properties[Ardor Yard Sign Artwork Back - ' + labelStamp + ']', ART.back.file, 'Ardor Yard Sign Artwork Back ' + fileStamp + ext(ART.back.name));
      if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, size: c.size.key, w: c.Wi, h: c.Hi, s: c.sides, b: c.sides === 2 ? S.backMode : '', n: c.pack, st: c.stake ? c.pack : 0, pack: p.pack, stakes: p.stakes }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          if (xhr.status === 413) msg = 'Your files are too big to upload with the order. Please try a smaller file, or request a quote.';
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      if (!c.stake) return null;
      return addStakeLine(c.pack).catch(function () { stakeFail = true; throw { stake: true }; });
    }).then(function () {
      track('ardor_yardsign_added_to_cart', { value: p.charged, size: c.size.key, sides: c.sides, signs: c.pack, stakes: c.stake ? c.pack : 0, quantity: 1 });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      if (err && err.stake) {
        // the signs went in but the stakes did not: do not add the signs a second time
        track('ardor_yardsign_added_to_cart', { value: p.pack, size: c.size.key, sides: c.sides, signs: c.pack, stakes: 0, quantity: 1 });
        btns.forEach(function (b) { b.disabled = false; b.textContent = 'Go to cart'; });
        showErr('Your signs are in your cart, but we could not add the H-stakes. Go to your cart to check out, then call ' + PHONE + ' and we will add the stakes.');
        return;
      }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Material: ' + MATERIAL);
    if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
    var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
    if (c.sides === 2) lines.push('Back: ' + (S.backMode === 'different' ? (ART.back ? ART.back.name : 'different art') : 'same as front'));
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Delivery: Free US shipping or pickup in Snohomish');
    lines.push('Online price shown: ' + money(p.charged) + ' (' + packLabel(c.pack) + ' ' + money(p.pack) + (c.stake ? ', H-stakes ' + money(p.stakes) : '') + ')');
    return lines.join('\n');
  }

  function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Yard signs from the Ardor Yard Sign Builder\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f)); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f)); });
    $$('[data-abb-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.face = b.getAttribute('data-abb-face'); S.back = S.face === 'back';
        render(); view3d(S.back ? 'back' : 'front');
      });
    });
    
    
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_yardsign_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    defer3D(); // YARD3D: was startEngine()
    window.ArdorYardSignBuilder = {
      state: S, sizes: SIZES, packs: PACKS, stake: STAKE, cfg: cfg, price: price, render: render, variantFor: variantFor, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); }
    };
    // used by ardor-yardsign-layers.js (text and clipart layers). Sizes are in inches (c.Wi x c.Hi).
    window.ArdorYardSignAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[face === 'back' ? 'back' : 'front']; },
      setArt: function (face, a) { ART[face === 'back' ? 'back' : 'front'] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      editFace: function () { return S.face === 'back' ? (S.backMode === 'different' ? 'back' : null) : 'front'; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; }
    };
    window.ArdorYardSignBuilder.proof = { noun: 'yard signs', file: 'Ardor Yard Sign Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:yardsign-api')); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
